import { isValidElement } from 'react'

import CheckmarkFilled from '@carbon/icons-react/lib/CheckmarkFilled'
import ErrorFilled from '@carbon/icons-react/lib/ErrorFilled'
import WarningFilled from '@carbon/icons-react/lib/WarningFilled'
import { Toaster, resolveValue } from 'react-hot-toast'
import { createStyles } from 'utils/css'
import { zIndexStack } from 'utils/theme'
import theme from 'utils/theme'
const { colors, fontSizes, spacing, radii, treatments } = theme

const styles = () =>
  createStyles(() => ({
    ...treatments.stackTop,
    '& > div': {
      zIndex: `${zIndexStack + 1} !important`
    }
  }))
const Toast = () => (
  <div data-testid='toast' css={styles}>
    <Toaster
      toastOptions={{
        position: 'top-center',
        duration: 4000,
        style: {
          borderRadius: radii.sm,
          padding: spacing(16, 'px', 1),
          color: colors.light,
          fontSize: fontSizes.md,
          width: 'auto',
          maxWidth: '600px',
          marginRight: spacing(1),
          ...treatments.stackTop
        },
        success: {
          icon: <CheckmarkFilled size={24} />,
          iconTheme: {
            primary: colors.success200,
            secondary: colors.light
          },
          style: {
            background: colors.success50,
            color: colors.success200,
            borderBottom: `4px solid ${theme.colors.success200}`
          }
        },
        loading: {
          icon: <WarningFilled size={16} />,
          iconTheme: {
            primary: colors.warning200,
            secondary: colors.warning50
          },
          style: {
            background: colors.warning50,
            color: colors.warning200,
            borderBottom: `4px solid ${theme.colors.warning200}`
          }
        },
        error: {
          icon: <ErrorFilled size={24} />,
          iconTheme: {
            primary: colors.red200,
            secondary: colors.light
          },
          style: {
            background: colors.danger50,
            color: colors.danger,
            borderBottom: `4px solid ${theme.colors.red200}`
          }
        }
      }}
    >
      {t => {
        // Using this way until we replace all toasts to use the new message styles
        const renderNewToastMessage = isValidElement(t.message)

        return (
          <div
            style={{
              ...t.style,
              ...(!renderNewToastMessage && {
                display: 'flex',
                alignItems: 'center'
              })
            }}
          >
            {renderNewToastMessage && resolveValue(t.message, t)}
            {!renderNewToastMessage && (
              <>
                <div style={{ marginRight: '8px' }}>{t.icon}</div>
                {resolveValue(t.message, t)}
              </>
            )}
          </div>
        )
      }}
    </Toaster>
  </div>
)
export default Toast
